/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';
import type { ReferralFilter } from './ReferralFilter';

export type ReferralViewRequest = {
    filter?: ReferralFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
    exposeType?: ReferralViewRequest.exposeType;
}

export namespace ReferralViewRequest {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
